import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getCompanyId } from '../../services/company/company';

const AutoSubscriptionMiddleware = ({ render, isAutoSub }: any) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { saveDataVerifyOnStorage, saveDataSignUpOnStorage } = useAuth();

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(location.search);
      const refer = params.get('refer');
      const utmSource = params.get('utm_source');
      const utmMedium = params.get('utm_medium');
      const utmCampaign = params.get('utm_campaign');

      if (
        refer === 'WebSummitRio2024' &&
        utmSource === 'events' &&
        utmMedium === 'shirt' &&
        utmCampaign === 'websummitrio2024'
      ) {
        localStorage.removeItem('zenbox.identity');
        localStorage.removeItem('zenbox.verify');
        localStorage.removeItem('zenbox.question');

        const autoSignupToken = process.env.REACT_APP_AUTO_SIGNUP_TOKEN;
        saveDataVerifyOnStorage({ verifyToken: autoSignupToken });

        const company = await getCompanyId(process.env.REACT_APP_AUTO_SIGNUP_ORG_ID);
        saveDataSignUpOnStorage({
          role: 3,
          company_visited: company?.Item ?? company?.company?.Item ?? company?.company ?? company,
          user_company: company?.Item ?? company?.company?.Item ?? company?.company ?? company,
        });

        localStorage.setItem('zenbox.websummitrio2024', JSON.stringify({ foo: 'bar' }));
        isAutoSub(true);
      } else {
        navigate('welcome');
      }
    };

    void run();
  }, [location.search, isAutoSub, navigate, saveDataSignUpOnStorage, saveDataVerifyOnStorage]);

  return render();
};

export default AutoSubscriptionMiddleware;
